import React, { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import LoadingComponent from "../../../components/Loading";

import { useSelector } from "react-redux";

import { selectUsuarioSeleccionado } from "../../../redux/reducer/loginReducer";
import TituloPagina from "../../../components/Titulos/TituloPagina";
import { getCmiAntiguosAlumnos, getCmiComerciales } from "../../../services/alumnos";
import {
  Box,
  Button,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  CircularProgress,
  Link,
  Table,
} from "@material-ui/core";
import { GaugeComponent } from "react-gauge-component";
import { getComerciales } from "../../../services/comerciales";
import { set } from "date-fns";
import { blue, grey } from "@material-ui/core/colors";

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "80px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    width: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  emptyImage: {
    width: "100%",
  },
  rootFilter: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textFieldFilter: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  enlace: {
    color: theme.palette.link.main,
    textDecoration: "none",
  },
}));

export default function CmiComercialContent() {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");
  const [comerciales, setComerciales] = useState([]);

  const [antiguosAlumnos, setAntiguosAlumnos] = useState([]);
  const [numAntiguosAlumnos, setNumAntiguosAlumnos] = useState(0);
  const [datosMelani, setDatosMelani] = useState([]);
  const [datosJennifer, setDatosJennifer] = useState([]);

  // const [estadisticasAntiguosAlumnosMotivoPerdida, setEstadisticasAntiguosAlumnosMotivoPerdida] = useState([])
  // const [estadisticasAntiguosAlumnosEstados, setEstadisticasAntiguosAlumnosEstados] = useState([])
  // const [loadingNumTotalAlumnos, setLoadingNumTotalAlumnos] = useState(false)
  // const [numTotalAlumnos, setNumTotalAlumnos] = useState(0)

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    setLoading(true);
    setLoadingMensaje("Cargando datos");

    const usuario_id = usuarioSeleccionado.id;
    getComerciales({ usuario_id }).then((response) => {
      setLoading(false);
      setComerciales(
        response.comerciales.filter((item) => item.es_estadistica === "1")
      );
    });
    
    getCmiAntiguosAlumnos({
      usuario: usuario_id,
      nombre_dato: "estadisticas",
    }).then((response) => {
      setLoading(false);
      setLoadingMensaje("");

      setAntiguosAlumnos(response.antiguos_alumnos);

      setNumAntiguosAlumnos(response.num_antiguos_alumnos);

      setDatosMelani(response.resultado.filter((item) => item.id === "9"));
      setDatosJennifer(response.resultado.filter((item) => item.id === "15" ));

    });

  }, []);

useEffect(() => {
    setLoading(true);
    setLoadingMensaje("Cargando datos");

    const usuario_id = usuarioSeleccionado.id;

    
  }, []);
  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */
  const ContenidoComercial = ({ comercial }) => {
    const [loadingEstadisticas, setLoadingEstadisticas] = useState(false);
    const [loadingAntiguosAlumnos, setLoadingAntiguosAlumnos] = useState(false);

    const [estadisticas, setEstadisticas] = useState([]);
    const [ventasMes, setVentasMes] = useState([]);
    const [objetivoVentasMes, setObjetivoVentasMes] = useState(0);
    const [datosEstadisticos, setDatosEstadisticos] = useState([]);

    /* -------------------------- Información comercial ------------------------- */
    useEffect(() => {
      const usuario_id = usuarioSeleccionado.id;

      setLoadingEstadisticas(true);
      setLoadingAntiguosAlumnos(true);

      getCmiComerciales({
        usuario: usuario_id,
        comercial_id: comercial.id,
        nombre_dato: "estadisticas",
      }).then((response) => {
        setLoadingEstadisticas(false);

        response && setEstadisticas([response.estadisticas]);
      });

    }, []);

    
    /* ----------------------------- Datos agrupados ---------------------------- */
    useEffect(() => {
      const da = estadisticas.map((estadistica) => {
        return estadistica;
      });

      if (comercial) {
        const dac = da[0];

        dac && setVentasMes(dac[comercial.usuario_id].ventas_mes);
        dac &&
          setObjetivoVentasMes(dac[comercial.usuario_id].objetivo_ventas_mes);
        dac && setDatosEstadisticos(dac[comercial.usuario_id].estadisticas);
      }
    }, [estadisticas]);

    return (
      <div style={{ display: "block" }}>
        <h3>{`${comercial.nombre}`}</h3>

        {ventasMes && objetivoVentasMes && (
          <>
            {/* Ventas del mes */}
            <Grid container style={{ margin: 0 }} spacing={2}>
              <Grid item xs={12} md={6} lg={4}>

                <Card style={{ marginBottom: "20px", width: "fit-content" }}>
                  <CardContent>
                    <Grid container spacing={4} style={{ margin: 0 }}>
                      <Grid item xs={7}>
                        <Typography variant="h5" component="div" gutterBottom>
                          Ventas del mes
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {ventasMes.length}/{objetivoVentasMes}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Box style={{ display: "flex", justifyContent: "center" }}>
                          <GaugeComponent
                            type="semicircle"
                            arc={{
                              width: 0.2,
                              padding: 0.005,
                              cornerRadius: 1,
                              subArcs: [
                                { limit: objetivoVentasMes * 0.5, color: "#ec7063" }, // Rojo pastel
                                { limit: objetivoVentasMes * 0.75, color: "#f4d03f" }, // Amarillo pastel
                                { limit: objetivoVentasMes, color: "#52be80" }, // Verde pastel
                              ],
                            }}
                            pointer={{
                              color: "#345243",
                              length: 0.6, // Ajusta la longitud del puntero
                              width: 10, // Ajusta el ancho del puntero
                              elastic: true,
                              type: "arrow",
                            }}
                            labels={{
                              valueLabel: {
                                formatTextValue: (value) => `${value} ventas`,
                                style: { textShadow: "none", fill: "black" },
                              },
                              tickLabels: {
                                type: "outer",
                                defaultTickValueConfig: {
                                  formatTextValue: (value) => `${value}`,
                                  style: { fontSize: 7 }, // Ajusta el tamaño de la fuente de las etiquetas
                                },
                                ticks: [
                                  { value: objetivoVentasMes * 0.5 },
                                  { value: objetivoVentasMes * 0.75 },
                                  { value: objetivoVentasMes },
                                ],
                              },
                            }}
                            value={ventasMes.length}
                            minValue={0}
                            maxValue={objetivoVentasMes}
                            style={{ width: "150px", height: "70px" }} // Ajusta el tamaño del GaugeComponent
                          />
                        </Box>
                      </Grid>

                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Grid container style={{ margin: 0 }} spacing={2}>

              {/* Indicadores antiguos alumnos */}
              <>
                <Grid item xs={12} md={6} lg={4}>
                  <CardIndicador
                    titulo={"ANTIGUOS ALUMNOS TOTALES"}
                    valor={numAntiguosAlumnos}
                  />
                </Grid>

                {comercial.usuario_id === "19" && (
                  <>
                    <Grid item xs={12} md={6} lg={4}>
                      <CardIndicador
                        titulo={"ANTIGUOS ALUMNOS MELANI"}
                        valor={datosMelani[0]?.alumnos?.length}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <CardIndicador
                        titulo={"RETENCION MELANI"}
                        valor={`${datosMelani[0]?.retencion} (${datosMelani[0]?.porcentaje_retencion}%)`}
                      />
                    </Grid>
                  </>
                )}

                {comercial.usuario_id === "115" && (
                  <>
                    <Grid item xs={12} md={6} lg={4}>
                      <CardIndicador
                        titulo={"ANTIGUOS ALUMNOS JENIFER"}
                        valor={datosJennifer[0]?.alumnos?.length}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <CardIndicador
                        titulo={"RETENCION JENIFER"}
                        valor={`${datosJennifer[0]?.retencion} (${datosJennifer[0]?.porcentaje_retencion}%)`}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} md={6} lg={4} style={{ marginBottom: 20 }}>
                  <Link href="/antiguos-alumnos" style={{color: blue[500]}}>Ver información completa de los antiguos alumnos</Link>
                </Grid>
              </>

            </Grid>
          </>          
        )}

        <Grid container style={{ margin: 0, display:"flex", flex: 1 }} spacing={2}>
          <Grid item style={{ display: "flex", flexDirection: "column", flex: 1 }}>

            <TableContainer component={Paper} style={{width: "100%"}}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        {item.fecha}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Total minutos</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.total_minutos) > 0 ? parseInt(item.total_minutos) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Total llamadas</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.total_llamadas) > 0 ? parseInt(item.total_llamadas) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Llamadas menos 3 min</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.llamadas_menos_tres_minutos) > 0 ? parseInt(item.llamadas_menos_tres_minutos) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Llamadas más 3 min</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.llamadas_mas_tres_minutos) > 0 ? parseInt(item.llamadas_mas_tres_minutos) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Leads gestionados</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.leads_gestionados) > 0 ? parseInt(item.leads_gestionados) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Leads quemados <span style={{color: "#a9a9a9"}}>(gestionados perdidos)</span></TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.leads_quemados) > 0 ? parseInt(item.leads_quemados) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Ventas</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.num_ventas) > 0 ? parseInt(item.num_ventas) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Demos enviadas</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.num_demos_enviadas) > 0 ? parseInt(item.num_demos_enviadas) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Enlaces de pago (no cobrados)</TableCell>
                    {datosEstadisticos.map((item) => (
                      <TableCell align="right">
                        { parseInt(item.num_enlaces_enviados_no_cobrados) > 0 ? parseInt(item.num_enlaces_enviados_no_cobrados) : "" }
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
        
          </Grid>
        </Grid>
        
      </div>
    );
  };

  const Contenido = () => {
    return (
      <>
        <TituloPagina titulo={"Principales indicadores de comerciales"} />

        <Box style={{ paddingRight: 20, paddingLeft: 20 }}>
          <Divider style={{ marginBottom: 10 }} />
          <Button
            variant="outlined"
            href="https://gestion.innovatiio.com/api/procesos/ringover_actualizacion_llamadas"
            target="_blank"
            rel="noreferrer"
            className={classes.enlace}
          >
            Sincronizar datos con Ringover ahora
          </Button>

          {comerciales &&
            comerciales.length > 0 &&
            comerciales.map((comercial) => {
              return (
                <ContenidoComercial
                  key={comercial.usuario_id}
                  comercial={comercial}
                />
              );
            })}
          
        </Box>
      </>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
      {loading ? (
        <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
      ) : (
        <Contenido />
      )}
    </div>
  );
}

const CardIndicador = ({titulo, valor}) => {
  return (
    <Card style={{ }}>
      <CardContent>
        <Grid item>
          <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
            {titulo}
          </Typography>
          <Typography variant="h3" color="textSecondary" style={{ fontWeight: "bold", textAlign: "right"}}>
            {valor}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  )
}
